import { render, staticRenderFns } from "./PolicyForm.vue?vue&type=template&id=6391cd9c"
import script from "./PolicyForm.vue?vue&type=script&lang=js"
export * from "./PolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports